interface FillRateIndicatorProps {
  fillRate: number | null;
  capacity: number;
  sold: number;
}

export default function FillRateIndicator({ fillRate, capacity, sold }: FillRateIndicatorProps) {
  // NULL fill rate = zero-capacity event (not yet configured or removed)
  if (fillRate === null || capacity === 0) {
    return (
      <div className="flex items-center gap-2">
        <div className="flex-1 h-2 bg-stone-200 dark:bg-stone-700 rounded-full overflow-hidden min-w-[60px]" />
        <span className="text-xs font-medium whitespace-nowrap text-stone-400 dark:text-stone-500">
          N/A
        </span>
      </div>
    );
  }

  const pct = Math.round(fillRate * 100);
  const barColor =
    pct >= 70 ? 'bg-green-500' : pct >= 30 ? 'bg-amber-500' : 'bg-red-500';
  const textColor =
    pct >= 70 ? 'text-green-700 dark:text-green-400' : pct >= 30 ? 'text-amber-700 dark:text-amber-400' : 'text-red-700 dark:text-red-400';

  return (
    <div className="flex items-center gap-2">
      <div className="flex-1 h-2 bg-stone-200 dark:bg-stone-700 rounded-full overflow-hidden min-w-[60px]">
        <div
          className={`h-full rounded-full transition-all ${barColor}`}
          style={{ width: `${Math.min(pct, 100)}%` }}
        />
      </div>
      <span className={`text-xs font-medium whitespace-nowrap ${textColor}`}>
        {pct}% ({sold}/{capacity})
      </span>
    </div>
  );
}
